exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active,.slide-leave-active{-webkit-transition:opacity .5s ease;transition:opacity .5s ease}.slide-enter{opacity:0}.slide-leave-to{opacity:0;-webkit-transform:transformY(200%)!important;transform:transformY(200%)!important}", ""]);

// exports
